<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Adjustment"
              bc1="App"
              bc2="Adjustment"
          ></Breadcrumb>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <section v-if="!showCheckInfo && !showProcessedInfo">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Make Adjustment</h4>
                </div>
                <div class="card-body">
                  <form class="form form-horizontal">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label></label>
                          </div>
                          <div class="col-sm-4">
                            <div class="input-group d-flex justify-content-center">
                              <span>Select User</span>
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="input-group d-flex justify-content-center">
                              <span>Select User Account</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Sender</label>
                          </div>
                          <div class="col-sm-5">
                            <div class="">
                              <SearchSelect
                                  v-model="selectedSender"
                                  url="v1/get-merchants"
                                  :filterParams="{flag: 'all', type: 3, partners:1}"
                                  :customLabelFn="customNameForMultiselect"
                                  placeholder="Search.."
                              />
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="input-group input-group-merge">
                              <select
                                  class="form-control"
                                  v-model="selectedSenderDetails"
                              >
                                <option
                                    :key="merchantDetailsIndex"
                                    :value="merchantDetails"
                                    v-for="(merchantDetails, merchantDetailsIndex) in senderMerchantDetailsData"
                                >
                                  {{ merchantDetails.account_title + ' / ' + merchantDetails.currency.code }}
                                </option>
                              </select>
                              <div v-if="senderDetailLoader" class="input-group-append">
                                <span class="input-group-text cursor-pointer">
                                  <div class="spinner-border text-primary spinner-border-sm"></div>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Receiver</label>
                          </div>
                          <div class="col-sm-5">
                            <div class="">
                              <SearchSelect
                                  v-model="selectedReceiver"
                                  url="v1/get-merchants"
                                  :filterParams="{flag: 'all', type: 3, partners:1}"
                                  :customLabelFn="customNameForMultiselect"
                                  placeholder="Search.."
                              />
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="input-group input-group-merge">
                              <select
                                  class="form-control"
                                  v-model="selectedReceiverDetails"
                              >
                                <option
                                    :key="receiverMerchantDetailsIndex"
                                    :value="receiverMerchantDetails"
                                    v-for="(receiverMerchantDetails, receiverMerchantDetailsIndex) in receiverMerchantDetailsData"
                                >
                                  {{
                                    receiverMerchantDetails.account_title + ' / ' + receiverMerchantDetails.currency.code
                                  }}
                                </option>
                              </select>
                              <div v-if="receiverDetailLoader" class="input-group-append">
                                <span class="input-group-text cursor-pointer">
                                  <div class="spinner-border text-primary spinner-border-sm"></div>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Amount</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group d-flex justify-content-center">
                              <input type="text" class="form-control" name="amount" v-model="amount" :class="
                                  errorBag.has('amount') ? 'is-invalid' : ''
                                " v-validate="'required'">
                            </div>

                            <small
                                v-show="errorBag.has('amount')"
                                class=""
                            >{{ "*" + errorBag.first("amount") }}</small
                            >
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-9 offset-sm-3 mt-5">
                        <button type="button" class="btn btn-primary mr-1" @click="checkAdjustment">Check Details</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section v-if="showCheckInfo">
          <div class="row ">
            <div class="col-md-12 col-12 ">
              <div class="card border-primary badge-glow">
                <div class="card-header">
                  <h4 class="card-title">Adjustment Details</h4>
                </div>
                <div class="card-body">
                  <div class="row ">
                    <div class="col-12">
                      <div class="form-group row">
                        <div class="col-sm-3">
                          <p class="text-dark font-weight-bolder">Receiver Account Title</p>
                        </div>
                        <div class="col-sm-9">
                          <div class="input-group">
                            <p class="text-warning font-weight-bolder">{{ receiverAccountTitle }}</p>
                          </div>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-sm-3">
                          <p class="text-dark font-weight-bolder">Sender Account Title</p>
                        </div>
                        <div class="col-sm-9">
                          <div class="input-group">
                            <p class="text-warning font-weight-bolder">{{ senderAccountTitle }}</p>
                          </div>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-sm-3">
                          <p class="text-dark font-weight-bolder">Amount</p>
                        </div>
                        <div class="col-sm-9">
                          <div class="input-group">
                            <p class="text-warning font-weight-bolder">
                              {{ parseFloat(finalAmount / 100).toFixed(2) }}</p>
                          </div>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-sm-3">
                          <p class="text-dark font-weight-bolder">Select Channel (optional)</p>
                        </div>
                        <div class="col-sm-6">
                          <multiselect
                              v-model="selectedChannel"
                              :options="channelList"
                              label="label"
                              track-by="id"
                              placeholder="Select Channel"
                              :loading="channelLoader"
                              variant="primary"
                              :custom-label="customStoreNameForMultiselect"
                          ></multiselect>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-sm-3">
                          <p class="text-dark font-weight-bolder">Description</p>
                        </div>
                        <div class="col-sm-6">
                          <textarea class="form-control" v-model="description" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12offset-sm-3 mt-5">
                    <button type="button" class="btn btn-primary mr-1" @click="processAdjustment">Process</button>
                    <button type="button" class="btn btn-secondary mr-1"
                            @click="showProcessedInfo =false;showCheckInfo =false">Back
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section v-if="showProcessedInfo">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card border-primary badge-glow">
                <div class="card-header">
                  <h2 class="card-title">Transaction Successfull</h2>
                </div>
                <div class="card-body">
                  <div class="row text-center">
                    <div class="col-12">
                      <h6 class="font-weight-bolder">Transaction Id : <span
                          class="text-success">{{ successTransactionId }}</span></h6>
                    </div>
                  </div>
                  <div class="row text-center">
                    <div class="col-12">
                      <button class="btn btn-primary btn-sm mt-2"
                              @click="showProcessedInfo =false;showCheckInfo =false;amount=''">Make Another Adjustment
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>

  </div>
  <!-- END: Content-->
</template>


<script>

import SearchSelect from "@/components/common/SearchSelect.vue";

export default {
  components: {SearchSelect},

  mounted() {


    // this.getMerchantData()


  },
  data() {
    return {
      channelLoader:false,
      showConfirmationModal: false,
      charges: '',
      description: '',
      paybleAmount: '',
      loader: false,
      currencyLoader: true,
      emailOrPhone: '',
      selectedCurrency: null,
      currencyData: [],
      fromDate: null,
      toDate: null,
      transactionTypes: [],
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
      url: "",
      storageKey: "make-adjustment",
      status: "",
      selectedSender: null,
      MerchantsData: [],
      senderMerchantDetailsData: [],
      selectedSenderDetails: null,
      selectedReceiver: null,
      receiverMerchantDetailsData: [],
      selectedReceiverDetails: null,
      amount: '',
      receiverAccountTitle: '',
      senderAccountTitle: '',
      finalAmount: '',
      showCheckInfo: false,
      showProcessedInfo: false,
      hash: '',
      successTransactionId: '',
      senderDetailLoader: false,
      receiverDetailLoader: false,
      channelList:[],
      selectedChannel:null


    }
  },
  methods: {
    customStoreNameForMultiselect ({ name,code }) {
      return `${name}/${code}`
    },
    customNameForMultiselect({email, first_name}) {
      return `${email} ${first_name}`
    },
    checkAdjustment() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.$store.dispatch('exportExcelLoader', true)
          let data = {
            senderAccountId: this.selectedSenderDetails.id,
            receiverAccountId: this.selectedReceiverDetails.id,
            amount: this.amount * 100,
          }
          this.channelLoader = true
          this.makeRequest("post", "v1/check-adjust-payment", data, {}, false).then(
              (callResponse) => {
                if (!callResponse.error) {
                  let code = callResponse.response.data.code;
                  let responseData = callResponse.response.data.data;
                  if (code == 200) {
                    this.finalAmount = responseData.amount
                    this.receiverAccountTitle = responseData.receiverAccountTitle
                    this.senderAccountTitle = responseData.senderAccountTitle
                    this.hash = responseData.hash
                    this.channelList = responseData.channels
                    this.showCheckInfo = true
                    this.showProcessedInfo = false
                  }
                }
                this.channelLoader = false
                this.$store.dispatch('exportExcelLoader', false)
              }
          );

        }
      })
    },
    processAdjustment() {
      this.$store.dispatch('exportExcelLoader', true)
      let data = {
        hash: this.hash,
        description:this.description
      }
      if(this.selectedChannel){
        data.channelId = this.selectedChannel.id
      }
      this.makeRequest("post", "v1/process-adjust-payment", data).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                this.successTransactionId = responseData.transactionId
                this.showCheckInfo = false
                this.showProcessedInfo = true;
                this.description = ''
              }
            }
            this.$store.dispatch('exportExcelLoader', false)
          }
      );
    },
    getMerchantData() {
      this.makeRequest("post", "v1/get-merchants", {flag: 'all', type: 3}, {}, false,true,[205]).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                this.MerchantsData = responseData;
                this.setSelectedMerchantValue();
              }
            }
          }
      );
    },
    setSelectedMerchantValue() {


      if (this.selectedSender == null && this.MerchantsData.length > 0) {
        this.selectedSender = this.MerchantsData[0];

      }

      if (this.selectedReceiver == null && this.MerchantsData.length > 0) {
        this.selectedReceiver = this.MerchantsData[0];

      }
    },
    getMerchantDetailsData(id, type = 'receiver') {
      if (type == 'sender') {
        this.senderDetailLoader = true
      } else {
        this.receiverDetailLoader = true
      }
      this.makeRequest("post", "v1/detail-merchant", {id: id}, {}, false,true,[205]).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                if (type == 'sender') {
                  this.senderMerchantDetailsData = responseData.accounts ? responseData.accounts : [];
                  this.setSelectedMerchantDetailsValue(type);
                } else {
                  this.receiverMerchantDetailsData = responseData.accounts ? responseData.accounts : [];
                  this.setSelectedMerchantDetailsValue(type);
                }
              }
            }
            if (type == 'sender') {
              this.senderDetailLoader = false
            } else {
              this.receiverDetailLoader = false
            }
          }
      );
    },
    setSelectedMerchantDetailsValue(type) {
      if (type == 'sender') {
        this.selectedSenderDetails = this.senderMerchantDetailsData[0];
      } else {
        this.selectedReceiverDetails = this.receiverMerchantDetailsData[0];
      }

    },
  },
  watch: {
    selectedSender(val) {
      this.selectedChannel = null
      this.selectedSenderDetails = null
      this.senderMerchantDetailsData = []
      if(val){
        this.getMerchantDetailsData(val.id, 'sender')
      }
    },
    selectedReceiver(val) {
      this.selectedChannel = null
      this.selectedReceiverDetails = null
      this.receiverMerchantDetailsData = []
      if(val){
        this.getMerchantDetailsData(val.id)
      }
    },
  },
}
</script>

